import { Injectable, Inject, forwardRef } from '@angular/core';
import 'rxjs/add/operator/map';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subscription } from 'rxjs/Subscription';
import { CookieService } from 'ngx-cookie';

import { DataService } from '../services/data.service';

const helper = new JwtHelperService();

@Injectable()
export class AuthService {
	headers: HttpHeaders;
	firstLogin: boolean = true;
	lastCookieCheck: number = 0;
	authToken: any = null;
	lastVisited: any = '/profilo-utente';

	aritUser: boolean = false;
	aritUserVerified: boolean = false;
	loggingOut: boolean = false;
	josso_submit: string = 'http://idp.egov.regione.abruzzo.it/josso/signon/usernamePasswordLogin.do';

	constructor(private dataService: DataService, private cookieService: CookieService){
		console.log("SRV|AS - ALIVE!");
		this.headers = new HttpHeaders();
		this.headers.append('Content-Type', 'application/json');

		//console.log("SRV|AS - localStorage", localStorage);
		let last = localStorage.getItem('last_visited');
		if(last){
			this.lastVisited = last;
		}
		this.loadToken();
	}

	resetLoginCookies() {
		this.cookieService.remove('josso_username');
		this.cookieService.remove('josso_password');
		this.cookieService.remove('JOSSO_LOGIN_ENDED');
	}

	getJossoUser(): any {
		//console.log("SRV|AS - GET-JOSSO-USER");
		this.aritUser = true;
		this.cookieService.put('verify_user','verify');
		return this.dataService.getCommon().getHttpClient().post<any>('/proxy/josso/josso-security-check.php', {});
	}

	registerUser(user: any) {
		return this.dataService.getCommon().getHttpClient().post<any>('/api/users/register', user);
	}

	authenticateUser(login: any) {
		return this.dataService.getCommon().getHttpClient().post<any>('/api/users/authenticate', login);
	}

	authenticateAritUser(login: any) {
		this.aritUser = true;
		this.cookieService.put('josso_username',login.josso_username);
		this.cookieService.put('josso_password',login.josso_password);
		this.dataService.navigateByUrl('/check-access');
	}

	storeUserData(token: any, user: any) {
		console.log("SRV|AS - STORE USER DATA");
		if (token) {
			localStorage.setItem('id_token', token);
			this.authToken = token;
		}
		localStorage.setItem('user', JSON.stringify(user));
		this.dataService.getUtentiService().setUser(user);
		this.setPermissions();
		this.dataService.getCommon().getSocket().addActivity(this.dataService.getUtentiService().getUser().id, null, "login", "", true);
	}

	loadToken() {
		const token = localStorage.getItem('id_token');
		if (token) {
			this.authToken = token;
			console.log("SRV|AS - LOAD TOKEN");
			//console.log("SRV|AS - LOAD TOKEN", token);
			this.verifyToken().subscribe(
				data => {
					//console.log("SRV|AS - VERIFY TOKEN", data);
					if (data.success) {
						this.dataService.getUtentiService().setUser(data.user);
						this.setPermissions();
						console.log("SRV|AS - USER VERIFIED", this.dataService.getUtentiService().getUser());
						this.dataService.getComuniService().loginByToken = true;
					}else {
						console.log("SRV|AS - TOKEN SCADUTO", data.msg);
						this.logout();
					}
				},
				error => { console.log("SRV|AS - VERIFYTOKEN ERROR:", error); }
			);
		}
	}

	setPermissions() {
		this.dataService.loadGeneral(this.lastVisited);
		console.log("SRV|AS - SET PERMISSIONS USER", this.lastVisited);
		//this.getLastAccessByUserID(this.dataService.getUtentiService().getUser().id);
		this.dataService.navigate([this.lastVisited]);
	}

	loggedIn(){
		if(this.aritUser){
			if(this.aritUserVerified){
				this.dataService.getComuniService().aritUser = true;
				//console.log("SRV|AS - loggedIn aritUserVerified");
				return true;
			}else{
				//console.log("SRV|AS - loggedIn NO aritUserVerified");
				return false;
			}
		}else{
			//console.log("SRV|AS - loggedIn NO aritUser", this.authToken, helper.isTokenExpired(this.authToken));
			return !helper.isTokenExpired(this.authToken);
		}
	}

	certificated() {
		return this.dataService.getUtentiService().getUser().certificazione;
	}

	verifyToken() {
		return this.dataService.getCommon().getHttpClient().post<any>('/api/users/verify', {token: this.authToken}, {headers: this.headers});
	}

	verifyAritUser(user) {
		return this.dataService.getCommon().getHttpClient().post<any>('/api/users/verify-arit', user, {headers: this.headers});
	}

	openMessage(title, content) {
		this.dataService.openMessage(title,content);
	}

	logout() {
		//console.log("SRV|AS - LOGOUT", this.dataService.getUtentiService().getUser());
		if(this.dataService.getUtentiService().getUser()){
			this.dataService.getCommon().getSocket().addActivity(this.dataService.getUtentiService().getUser().id, null, "logout", "", true);
		}else{
			let user = JSON.parse(localStorage.getItem('user'));
			this.dataService.getCommon().getSocket().addActivity(user.id, null, "logout", "", true);
		}
		this.firstLogin = true;
		this.authToken = null;
		this.dataService.getComuniService().loginByToken = false;
		this.dataService.getComuniService().aritUser = false;
		this.dataService.getUtentiService().resetUser();
		this.aritUser = false;
		this.aritUserVerified = false;
		this.lastVisited = '/profilo-utente';
		this.dataService.getComuniService().resetComune();
		this.cookieService.removeAll();
		localStorage.clear();
		this.dataService.navigateByUrl('/check-access');
	}
}
